import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import api from "../../config/axiosConfig";
import "./Home.css";

export default function Home() {
  const [examens, setExamens] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTabs, setSelectedTabs] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [tempSelectedTabs, setTempSelectedTabs] = useState([]);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [rapportTypesLoaded, setRapportTypesLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showStats, setShowStats] = useState(false);
  const statsRef = useRef(null);

  const [showEtabModal, setShowEtabModal] = useState(false);
  const [etablissements, setEtablissements] = useState([]);
  const [selectedEtabId, setSelectedEtabId] = useState(
    localStorage.getItem("tenant") || null
  );


 const [dateMin, setDateMin] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - 7);
    return d;
  });
  const [dateMax, setDateMax] = useState(new Date());

  const navigate = useNavigate();



   const formatDate = (d) =>
    d.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });

  const normalizeEtablissements = (payload) => {
    const list = [];
    const pushOne = (x) => {
      if (!x) return;
      if (typeof x === "number" || typeof x === "string") {
        list.push({ id: Number(x), nom: `Établissement #${x}` });
      } else if (typeof x === "object") {
      list.push({
        id: x.id,
        publicId: x.publicId,  
        nom: x.nom,
        ville: x.ville,
        pays: x.pays,
      });
      }
    };
    Array.isArray(payload) ? payload.forEach(pushOne) : pushOne(payload);
    // dédupe
    const seen = new Map();
    list.forEach((e) => {
      const k = String(e.id);
      if (!seen.has(k)) seen.set(k, e);
    });
    return Array.from(seen.values());
  };

    // NEW — charge les établissements pour l’utilisateur connecté
  const fetchEtablissements = async () => {
    const token = localStorage.getItem("token");
    const username = localStorage.getItem("login");
    if (!token || !username) return;

    try {
      const res = await api.get(
        `${process.env.REACT_APP_EUREKA_PACS_URL}/user/etablissements/${username}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const normalized = normalizeEtablissements(res.data);
      setEtablissements(normalized);

      // Si aucun tenant n’est défini, on prend le premier disponible
      if (!localStorage.getItem("tenant") && normalized.length) {
        localStorage.setItem("tenant", normalized[0].publicId);
        setSelectedEtabId(String(normalized[0].publicId));
      }
    } catch (e) {
      console.error("Erreur chargement établissements :", e);
    }
  };

  // NEW — charger au montage (et tu peux recharger à l’ouverture du modal aussi)
  useEffect(() => {
    fetchEtablissements();
  }, []);


  useEffect(() => {
  function handleClickOutside(event) {
    if (statsRef.current && !statsRef.current.contains(event.target)) {
      setShowStats(false);
    }
  }

  if (showStats) {
    document.addEventListener("mousedown", handleClickOutside);
  } else {
    document.removeEventListener("mousedown", handleClickOutside);
  }

  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [showStats]);


  const modalityMap = {
    "Radiographie conventionnelle": "CR",
    "Radiographie numérique": "DX",
    "Tomodensitométrie (Scanner)": "Scanner",
    "Imagerie par résonance magnétique (IRM)": "IRM",
    "Échographie": "ECHO",
    "Médecine nucléaire": "MN",
    "Tomographie par émission de positons (TEP/PET scan)": "TEP/PET ",
    "Angiographie": "ANGIO",
    "Mammographie": "MAMMO",
    "Fluoroscopie": "FLUORO",
    "Endoscopie": "ENDO",
    "Densitométrie osseuse (DXA)": "DENSI",
    "Capture secondaire d'image": "CAPTURE",
    "Autre modalité": "AUTRE",
    "IRM (non standard, mappée vers MR)": "IRM MR",
  };

  const currentEtab = etablissements.find(
  (e) => String(e.publicId) === String(selectedEtabId)
);


  const [advancedFilters, setAdvancedFilters] = useState({
    patientNom: "",
    patientPrenom: "",
    radiologueNom: "",
    type: "",
    criticite: "",
    statut: "",
    dateMin: "",
    dateMax: "",
  });

  const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);

  // ====== API: charger les examens (extrait hors useEffect pour réutiliser) ======
const fetchExamens = async () => {
  const token = localStorage.getItem("token");
  const tenantId = localStorage.getItem("tenant");
  if (!token || !tenantId) return;

  setIsLoading(true);

  try {
    const response = await api.get(
      `${process.env.REACT_APP_EUREKA_PACS_URL}/api/examens`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "X-Tenant-Id": tenantId,
        },
        params: {
          dateMin: dateMin.toISOString(),
          dateMax: dateMax.toISOString(),
        },
      }
    );

    setExamens(response.data);
  } catch (error) {
    console.error("Erreur lors du chargement des examens :", error);
  } finally {
    setIsLoading(false);
  }
};




  // Fermer le menu profil au clic extérieur
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-menu") && !e.target.closest(".profil")) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Charger les examens au montage
  useEffect(() => {
    fetchExamens();
  }, []);

  // 🎯 Récupérer les types autorisés pour l'utilisateur (1 seule fois)
  useEffect(() => {
    const fetchRapportTypes = async () => {
      const token = localStorage.getItem("token");
      const username = localStorage.getItem("login");
      if (!token || !username) return;

      try {
        const response = await api.get(
          `${process.env.REACT_APP_EUREKA_PACS_URL}/api/rapportTypes/user/${username}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const typesAutorises = response.data
          .map((rt) => rt?.typeExamen?.libelle)
          .filter(Boolean);

        setSelectedTabs(typesAutorises);
        setTempSelectedTabs(typesAutorises);
        setRapportTypesLoaded(true);
      } catch (error) {
        console.error("Erreur récupération des types d'examen autorisés :", error);
      }
    };

    if (!rapportTypesLoaded) fetchRapportTypes();
  }, [rapportTypesLoaded]);

const filteredExamens = examens.filter((examen) => {
  if (selectedTabs.length > 0 && !selectedTabs.includes(examen.type)) return false;

  const {
    patientNom,
    patientPrenom,
    radiologueNom,
    type,
    criticite,
    dateMin,
    dateMax,
    statut,
  } = advancedFilters;

  const nomPatient = examen.patient?.personne?.nom?.toLowerCase() || "";
  const prenomPatient = examen.patient?.personne?.prenom?.toLowerCase() || "";
  const nomRadiologue = examen.radiologue?.personne?.nom?.toLowerCase() || "";
  const typeExamen = examen.type?.toLowerCase() || "";
  const criticiteExamen = examen.criticite?.toLowerCase() || "";
  const dateExamen = examen.created_at ? new Date(examen.created_at) : null;

  if (patientNom && !nomPatient.includes(patientNom.toLowerCase())) return false;
  if (patientPrenom && !prenomPatient.includes(patientPrenom.toLowerCase())) return false;
  if (radiologueNom && !nomRadiologue.includes(radiologueNom.toLowerCase())) return false;
  if (type && !typeExamen.includes(type.toLowerCase())) return false;
  if (criticite && !criticiteExamen.includes(criticite.toLowerCase())) return false;

  // Dates (bornes inclusives)
  if (dateMin && dateExamen) {
    const minDate = new Date(dateMin + "T00:00:00");
    if (dateExamen < minDate) return false;
  }
  if (dateMax && dateExamen) {
    const maxDate = new Date(dateMax + "T23:59:59");
    if (dateExamen > maxDate) return false;
  }

  // Statut (gérer null comme "A VALIDER")
  const statutExamen = examen.statut || "A VALIDER";
  if (statut && statutExamen !== statut) return false;

  // Recherche plein texte
  const fullText = Object.entries(examen)
    .flatMap(([_, value]) => {
      if (value == null) return [];
      if (typeof value === "object") {
        return Object.entries(value).flatMap(([__, nestedValue]) => {
          if (nestedValue == null) return [];
          if (typeof nestedValue === "object") {
            return Object.values(nestedValue).filter(Boolean);
          }
          return nestedValue;
        });
      }
      return value;
    })
    .join(" ")
    .toLowerCase();

  return fullText.includes(searchTerm.toLowerCase());
});


  const tabNames = Object.keys(modalityMap);

  const toggleModal = () => {
    setTempSelectedTabs(selectedTabs);
    setShowFilterModal(!showFilterModal);
  };

  const handleCheckboxChange = (modality) => {
    setTempSelectedTabs((prev) =>
      prev.includes(modality)
        ? prev.filter((m) => m !== modality)
        : [...prev, modality]
    );
  };

  const applyFilters = () => {
    setSelectedTabs(tempSelectedTabs);
    setShowFilterModal(false);
  };

  const calculerAge = (dateNaissanceStr) => {
    if (!dateNaissanceStr) return null;
    const naissance = new Date(dateNaissanceStr);
    const maintenant = new Date();
    let age = maintenant.getFullYear() - naissance.getFullYear();
    const m = maintenant.getMonth() - naissance.getMonth();
    if (m < 0 || (m === 0 && maintenant.getDate() < naissance.getDate())) {
      age--;
    }
    return age;
  };

  return (
    <div className="dark">
      <header>
        <div className="logo">
 
  <h1>Eureka PACS</h1>


</div>
 
       
        <div className="controls">
          
        <img onClick={fetchExamens} src="/refresh-icon.png" alt="Actualisation" className="icon refresh-icon" />
 
          
          <input
            type="text"
            placeholder="Rechercher par patient"
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button onClick={toggleModal}>Filtrer par modalité</button>
          <button onClick={() => setShowAdvancedSearchModal(true)}>
            Recherche avancée
          </button>
          
  {(authService.isRadiologue()|| authService.isTechnicien()) && (
          <button onClick={() => navigate("/load")}>
            Téléverser fichiers
          </button>
          )}
          <img
            src="/profil.png"
            alt="profil"
            className="icon profil"
            onClick={() => setShowProfileMenu(!showProfileMenu)}
            style={{ cursor: "pointer" }}
          />
        </div>
       
      </header>

      <main>
        {/* Compteur total */}
  {/* Compteur + établissement sur une ligne */}
<div className="exam-header">
  <div className="exam-count">
  {filteredExamens.length} examen{filteredExamens.length > 1 ? "s" : ""} trouvé{filteredExamens.length > 1 ? "s" : ""}

  
  <span
    className="info-icon"
    onClick={() => setShowStats(!showStats)}
    title="Voir les statistiques"
  >
    ℹ️
  </span>

     <div className="filter-info">
              📅 Période : {formatDate(dateMin)} → {formatDate(dateMax)}
            </div>

 {showStats && (
  <div className="stats-popup" ref={statsRef}>
    <div className="stats-header">
      <h4>📊 Statistiques</h4>
      <button className="close-btn" onClick={() => setShowStats(false)}>✖</button>
    </div>
    <p>Total : <strong>{filteredExamens.length}</strong></p>
    <p>Terminé (TERMINE) : <strong>{filteredExamens.filter(e => e.statut === "TERMINE").length}</strong></p>
    <p>Avec CR (AVEC_CR) : <strong>{filteredExamens.filter(e => e.statut === "AVEC_CR").length}</strong></p>
    <p>À valider : <strong>{filteredExamens.filter(e => !e.statut).length}</strong></p>
  </div>
)}


</div>


  {currentEtab && (
    <div className="current-etab">
      🏥 {currentEtab.nom}
    </div>
  )}
</div>

  {/* Filtres rapides par modalités détectées */}
<div className="modalities-bar">
  {Array.from(new Set(examens.map((ex) => ex.type))).map((type) => (
    <button
      key={type}
      className={`modality-chip ${selectedTabs.includes(type) ? "active" : ""}`}
      onClick={() =>
        setSelectedTabs((prev) =>
          prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
        )
      }
    >
      {Object.keys(modalityMap).find((key) => modalityMap[key] === type) || type}
    </button>
  ))}
</div>
<div className="table-wrapper">
        <table>
<thead>
  <tr>
    <th className="col-hide">Numero</th>
    <th className="col-hide">Nom de l'examen</th>
    <th className="col-hide">Type</th>
    <th className="col-date">Date</th>
    <th className="col-hide">Statut</th>
    <th className="col-hide">Criticité</th>
    <th className="col-patient">Patient</th>
    <th className="col-hide">Âge</th>
    <th className="col-hide">Sexe</th>
    <th className="col-hide">Radiologue</th>
    <th className="col-hide">Action</th>
  </tr>
</thead>

<tbody>
  {filteredExamens.map((examen) => (
    <tr key={examen.id}  className={
        examen.statut === "TERMINE"
          ? "green-background"
          : examen.statut === "AVEC_CR"
          ? "orange-background"
          : "red-background"
      }
      onClick={() => navigate(`/examens/${examen.publicId}`)}>
      <td className="col-hide">{examen.id}</td>
      <td className="col-hide">{examen.nom}</td>
      <td className="col-hide">{examen.type}</td>
      <td className="col-date">
        {new Date(examen.created_at).toLocaleString("fr-FR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit"
})}
      </td>
      <td className="col-hide">
        {examen.statut || "A VALIDER"}
      </td>
      <td className="col-hide">{examen.criticite}</td>
      <td className="col-patient">
        {examen.patient?.personne?.nom} {examen.patient?.personne?.prenom}
      </td>
      <td className="col-hide">{calculerAge(examen.patient?.personne?.date_naissance)} ans</td>
      <td className="col-hide">{examen.patient?.personne?.sexe}</td>
      <td className="col-hide">
        {examen.radiologue?.personne?.nom} {examen.radiologue?.personne?.prenom}
      </td>
      <td className="col-hide action-cell">
        <img src="/rapport.png" alt="rapport" className="rapport-icon" />
      </td>
    </tr>
  ))}
</tbody>


        </table>
        </div>
      </main>

      {/* Modal de filtre */}
{showFilterModal && (
  <div className="modal-overlay">
    <div className="exam-modal">
      <h3>Sélectionnez les modalités à afficher</h3>
      <div className="modal-checkboxes">
        {tabNames.map((tab, index) => (
          <label key={index} className="checkbox-label">
            <input
              type="checkbox"
              checked={tempSelectedTabs.includes(tab)}
              onChange={() => handleCheckboxChange(tab)}
            />
            {tab}
          </label>
        ))}
      </div>
      <div className="modal-buttons">
        {/* ✅ CORRECTION : Utiliser applyFilters au lieu de fetchExamens */}
        <button
          className="apply-button"
          onClick={applyFilters}
        >
          Appliquer
        </button>

        <button
          className="reset-button"
          onClick={() => {
            setTempSelectedTabs([]);
            setShowFilterModal(false);
          }}
        >
          Réinitialiser
        </button>
      </div>
    </div>
  </div>
)}

{showAdvancedSearchModal && (
  <div className="modal-overlay">
    <div className="exam-modal">
      <h3>Recherche Avancée</h3>
      <div className="advanced-search-inputs">
        <input
          placeholder="Nom du patient"
          value={advancedFilters.patientNom}
          onChange={(e) =>
            setAdvancedFilters({ ...advancedFilters, patientNom: e.target.value })
          }
        />
        <input
          placeholder="Prénom du patient"
          value={advancedFilters.patientPrenom}
          onChange={(e) =>
            setAdvancedFilters({ ...advancedFilters, patientPrenom: e.target.value })
          }
        />
        <input
          placeholder="Nom du radiologue"
          value={advancedFilters.radiologueNom}
          onChange={(e) =>
            setAdvancedFilters({ ...advancedFilters, radiologueNom: e.target.value })
          }
        />
        <label>
          Date min :
          <input
            type="date"
            value={dateMin.toISOString().split("T")[0]}
            onChange={(e) => setDateMin(new Date(e.target.value))}
          />
        </label>

        <label>
          Date max :
          <input
            type="date"
            value={dateMax.toISOString().split("T")[0]}
            onChange={(e) => setDateMax(new Date(e.target.value))}
          />
        </label>
        <label>
          Statut :
          <select
            value={advancedFilters.statut}
            onChange={(e) =>
              setAdvancedFilters({ ...advancedFilters, statut: e.target.value })
            }
          >
            <option value="">Tous</option>
            <option value="AVEC_CR">Avec Compte-Rendu</option>
            <option value="TERMINE">Terminé</option>
            <option value="A VALIDER">À valider</option>
          </select>
        </label>

        <label>
          Criticité :
          <select
            value={advancedFilters.criticite}
            onChange={(e) =>
              setAdvancedFilters({ ...advancedFilters, criticite: e.target.value })
            }
          >
            <option value="">Toutes</option>
            <option value="Faible">Faible</option>
            <option value="Moyen">Moyen</option>
            <option value="Forte">Forte</option>
          </select>
        </label>
      </div>
      
      <div className="modal-buttons">
        {/* ✅ CORRECTION : Fermer la modale ET recharger les examens */}
        <button
          className="apply-button"
          onClick={() => {
            setShowAdvancedSearchModal(false);
            fetchExamens(); // 🔥 Recharge avec les nouveaux filtres de date
          }}
        >
          Appliquer
        </button>

        <button
          className="reset-button"
          onClick={() => {
            // Réinitialiser tous les filtres
            setAdvancedFilters({
              patientNom: "",
              patientPrenom: "",
              radiologueNom: "",
              type: "",
              criticite: "",
              statut: "",
              dateMin: "",
              dateMax: "",
            });
            
            // Réinitialiser les dates à 7 jours par défaut
            const now = new Date();
            const lastWeek = new Date();
            lastWeek.setDate(now.getDate() - 7);
            setDateMin(lastWeek);
            setDateMax(now);

            // Fermer et recharger
            setShowAdvancedSearchModal(false);
            fetchExamens(); // ⚡ Recharge avec la semaine par défaut
          }}
        >
          Réinitialiser
        </button>
      </div>
    </div>
  </div>
)}

{showProfileMenu && (
  <div className="profile-menu">
    <button onClick={() => navigate("/profil")}>👤 Afficher le profil</button>
    {(authService.isRadiologue() || authService.isTechnicien()) && (
      <button onClick={() => navigate("/saisie")}>📝 Saisie de Rapport Type</button>
    )}

    {/* NEW — bouton pour ouvrir le pop-up des établissements */}
    <button
      onClick={() => {
        fetchEtablissements(); // au cas où
        setShowEtabModal(true);
      }}
    >
      🏥 Changer d’établissement
    </button>

    <button
      onClick={() => {
        localStorage.removeItem("token");
        navigate("/");
      }}
    >
      🔒 Déconnexion
    </button>
  </div>
)}


      {isLoading && (
  <div className="modal-overlay">
    <div className="spinner-modal">
      <div className="spinner" />
      <p>Chargement en cours...</p>
    </div>
  </div>
)}

{/* NEW — Modal sélection d’établissement */}
{showEtabModal && (
  <div className="modal-overlay">
    <div className="exam-modal">
      <h3>Choisir un établissement</h3>

      {etablissements.length === 0 ? (
        <p>Aucun établissement disponible.</p>
      ) : (
        <div className="modal-checkboxes">
          {etablissements.map((e) => (
            <label key={e.publicId} className="checkbox-label">
              <input
                type="radio"
                name="etablissement"
                checked={String(selectedEtabId) === String(e.publicId)}
                onChange={() => setSelectedEtabId(String(e.publicId))}
              />
              {e.nom}
              {e.ville ? ` — ${e.ville}` : ""}
              {e.pays ? `, ${e.pays}` : ""}
            </label>
          ))}
        </div>
      )}

      <div className="modal-buttons">
        <button
          className="apply-button"
          onClick={() => {
            if (selectedEtabId) {
              localStorage.setItem("tenant", selectedEtabId); // ✅ important
              setShowEtabModal(false);
              fetchExamens(); // recharge la liste selon le nouveau tenant
            }
          }}
        >
          Valider
        </button>
        <button className="reset-button" onClick={() => setShowEtabModal(false)}>
          Annuler
        </button>
      </div>
    </div>
  </div>
)}


    </div>
  );
}
